import { usePlatformListSyncUpgrades } from '@cloudquery/api-platform';
import { useBaseAuthenticated } from '@cloudquery/base-users';
import { ErrorBox, Loader, assertUnreachable } from 'shared/base';

import { PlatformVersionUpgradeDetailsLayout } from './platformVersionUpgradeDetailsLayout';

interface Props {
  newVersion: string;
  newVersionReleaseDate: Date;
  oldVersion: string;
}

export const PlatformVersionUpgradeDetails = ({
  newVersion,
  newVersionReleaseDate,
  oldVersion,
}: Props) => {
  const { currentMembership } = useBaseAuthenticated();

  const { data: syncUpgrades, status } = usePlatformListSyncUpgrades(currentMembership.team.name, {
    page: 1,
    per_page: 1000,
    platform_version: newVersion,
  });

  switch (status) {
    case 'loading': {
      return <Loader />;
    }
    case 'error': {
      return (
        <ErrorBox
          message="Sorry, something went wrong. Please try again later."
          title="Error loading platform version upgrade summary"
        />
      );
    }
    case 'success': {
      return (
        <PlatformVersionUpgradeDetailsLayout
          newVersion={newVersion}
          newVersionReleaseDate={newVersionReleaseDate}
          oldVersion={oldVersion}
          pluginUpgrades={syncUpgrades.data.items}
        />
      );
    }
    default: {
      return assertUnreachable(status);
    }
  }
};
